import { TextWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';

export const MyFairValueTooltip = () => (
  <TextWrapper rowGap="8px">
    <Text typography="tiny" color="spaceGray">
      Fair value is the current intrinsic value of a company based on an
      estimate of its potential future profits.
    </Text>
    <Text typography="tiny" color="spaceGray">
      You can choose from community contributed, analysts consensus or your own
      valuation.
    </Text>
    <Text typography="tiny" color="spaceGray">
      Learn more about valuation on our Help Centre
    </Text>
  </TextWrapper>
);
